module.exports = __webpack_public_path__ + "img/club.6881d702.png";